import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'sort-arrow-icon',
  templateUrl: './sort-arrow-icon.component.html',
  styles: [':host { line-height: 0; }'],
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false
})
export class SortArrowIconComponent {}
